export default __webpack_public_path__ + "static/media/vertical.f01a8098.jpg";